define(function (require) {
    var $ = require("jquery");

    $(".lang-selector").on("change", function (ev) {

        var $destUrl = window.location.pathname;
        var $newLang = $(ev.target).val();

        // strip out language selector if pathname begins with one
        if (/^\/[a-zA-Z]{2}(\/|$)/.test($destUrl)) {
            // lop off the current 2-letter language code virtual directory
            $destUrl = $destUrl.slice(3);
            if ($destUrl.length === 0) {
                $destUrl = "/";
            }
        }

        // drop a cookie to remember the language selection
        document.cookie = "scan_lang=" + $newLang + ";max-age=31536000;path=/";
        // refresh to the same page using new language virtual directory
        if ($newLang === "en") {
            window.location.href = $destUrl + window.location.search;
        } else {
            window.location.href = "/" + $newLang + $destUrl + window.location.search;
        }
    });

    $(".lang-selector-sel").on("change", function (ev) {
        var $newLang = $(ev.target).val();
        var $destUrl = window.location.pathname;

        // strip out language selector if pathname begins with one
        if (/^\/[a-zA-Z]{2}(\/|$)/.test($destUrl)) {
            // lop off the current 2-letter language code virtual directory
            $destUrl = $destUrl.slice(3);
            if ($destUrl.length === 0) {
                $destUrl = "/";
            }
        }

        // drop a cookie to remember the language selection
        document.cookie = "scan_lang=" + $newLang + ";max-age=31536000;path=/";
        // refresh to the same page using new language virtual directory
        if ($newLang === "en") {
            window.location.href = $destUrl + window.location.search;
        } else {
            window.location.href = "/" + $newLang + $destUrl + window.location.search;
        }
    });
});
